import React from "react";
import { Outlet } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";
import PapelPicado from "./PapelPicado";
import PetalField from "./PetalField";

/** Shared chrome for the public pages: drifting petals, navigation, cut-paper garland, content and footer. */
const Layout = () => (
  <>
    <PetalField />
    <Navigation />
    <PapelPicado />
    <main className="page">
      <Outlet />
    </main>
    <Footer />
  </>
);

export default Layout;
